import styled from 'styled-components';
import { palette } from 'styles/colors';

export const FormResponseWrapper = styled.div`
  font-size: 24px;
  font-weight: 300;
  text-align: left;
  border-left: 2px solid ${palette.proBlue};
  padding-left: 20px;
  margin-top: 30px !important; // !important's needed to override the Layout styles
  max-width: 540px !important;

  a {
    color: ${palette.proBlue};
    text-decoration: none;
  }
`;
